<div *ngFor="let item of (messages | async)?.message" [ngClass]="getTypeMessage(item?.type)" class="dx-toast-content dx-toast-custom">
    <div class="dx-toast-icon"></div>
    <div class="dx-toast-message">{{item?.message}}</div>
</div>

